import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { DiaryEventKeySet } from "../../utils/diary-event-key-set"
import { DiaryEventGroup } from "../../models/diary-event-group"

@Component({
  selector: 'mojo-calendar-duodecennial-view',
  templateUrl: './calendar-duodecennial-view.component.html',
  styleUrls: ['./calendar-duodecennial-view.component.scss']
})
export class CalendarDuodecennialViewComponent implements OnInit, OnChanges {
  selectedYearItems: Array<any> = [];
  allAvailableYears: Array<any> = [];

  @Output() onItemClicked = new EventEmitter<any>();
  @Input() date: Date;
  @Input() fromYear: Number = 1980;
  @Input() toYear: Number = 2208;

  private _diaryEvents: DiaryEventGroup[];
  private _diaryEventKeySet: DiaryEventKeySet = new DiaryEventKeySet([]);

  @Input() set diaryEvents(value: DiaryEventGroup[]) {
    this._diaryEvents = value;
    this._diaryEventKeySet = new DiaryEventKeySet(this._diaryEvents);
  }

  get diaryEvents(): DiaryEventGroup[] {
    return this._diaryEvents;
  }

  hasEvents(year: number): boolean {
    return this._diaryEventKeySet.hasEventsInYear(year);
  }


  constructor() {
    this.allAvailableYears = this.getYears(this.fromYear, this.toYear);
  }

  itemClicked(item) {
    this.onItemClicked.emit(item.value);
  }

  ngOnChanges() {
    this.selectedYearItems = this.getCurrentRangeOfYears();
  }

  ngOnInit() {
  }

  getCurrentRangeOfYears(): Array<any> {
    let result = [];
    let currentYear = this.date.getUTCFullYear();
    this.allAvailableYears.forEach((array: Array<any>) => {
      if (array.some((value, index, array) => value.value == currentYear)) {
        result = array;
      }
    });
    return result;
  }

  getYears(startYear, endYear): Array<number> {
    let years = [];

    while (startYear < endYear) {
      if (startYear % 12 == 0) {
        let range = [];
        for (let i = startYear; i <= startYear + 11; i++) {
          range.push({ text: String(i), value: i });
        }
        years.push(range);
      }
      startYear++;
    }

    return years;
  }
}
